import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CompanyCollectorIdentifierResponseDto } from '@domain/company-collector-identifier/dtos/company-collector-identifier.response.dto';
import { ListCompanyCollectorIdentifierRequestDto } from '@domain/company-collector-identifier/dtos/list-company-collector-identifier-request.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CreateCompanyCollectorIdentifierRequestDto } from '@domain/company-collector-identifier/dtos/create-company-collector-identifier-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorIdentifierService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector/identifier');
  }

  list(request: ListCompanyCollectorIdentifierRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CompanyCollectorIdentifierResponseDto>>
    >(queryUrl, {
      params: { ...request },
    });
  }

  create(request: CreateCompanyCollectorIdentifierRequestDto) {
    const queryUrl = `${this.getApiUrl()}/`;
    return this.http.post<ApiResponse<CompanyCollectorIdentifierResponseDto>>(
      queryUrl,
      request,
    );
  }

  delete(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}`;
    return this.http.delete<ApiResponse<CompanyCollectorIdentifierResponseDto>>(
      queryUrl,
    );
  }
}
